import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import { useTranslation } from 'react-i18next';

interface IProps {
  open: boolean;
  title?: string;
  handleClose: () => void;
  handleSubmit: () => void;
}

const ConfirmDelete = ({ open, title, handleClose, handleSubmit }: IProps) => {
  const { t } = useTranslation();

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        className={'MuiModalBody'}
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          width: { xs: '80%', lg: '30%' },
        }}
      >
        <Typography id="modal-modal-title" variant="h5">
          {t('general.deleteTitle')}
        </Typography>
        {/*<img src="/images/icons/delete-icon.svg" alt="Delete icon" />*/}
        <Typography id="modal-modal-description" sx={{ my: 3 }} component={'p'}>
          {t('general.deleteText', { title })}
        </Typography>
        <div>
          <Button
            variant={'contained'}
            color={'secondary'}
            size={'small'}
            onClick={handleClose}
            sx={{ marginRight: '10px' }}
          >
            {t('button.cancel')}
          </Button>
          <Button variant={'contained'} size={'small'} onClick={handleSubmit}>
            {t('button.delete')}
          </Button>
        </div>
      </Box>
    </Modal>
  );
};

export default ConfirmDelete;
